var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-wrap"},_vm._l((_vm.getValues),function(value,key){return _c('b-badge',{key:key,staticClass:"mb-1",attrs:{"pill":"","variant":"light-secondary"}},[_vm._v(" "+_vm._s(value)+" ")])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }